import API from "./urls";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
import IHttpRequest from "src/http/http-request";

/**
 * 发送ajax请求
 * @param {any} options 请求参数
 * @param {string} url 请求地址
 * @param {string} method 请求类型
 * @returns {any}
 */
const send = (url: string, options?: IHttpRequest, method: any = "post"): IHttpResponse => {
  // 如果未传入url以及参数抛出异常
  if (!url) {
    throw new Error("url is null.");
  }

  // 返回promise实例由用户处理
  return HttpClient.instance[method]({
    url,
    ...options,
  });
};

/**
 * 接口类
 * @version 1.0.0
 */
export default class Apis {
  // file
  public upload = (option?: IHttpRequest) => send(API.upload, option);
  public editDirectory = (option?: IHttpRequest) => send(API.directoryBase, option, "put");
  public addDirectory = (option?: IHttpRequest) => send(API.directoryBase, option);
  public getDirectoryList = (option?: IHttpRequest) => send(API.getDirectoryList, option);
  public deleteDirectory = (option?: IHttpRequest) => send(API.directoryDetail, option, "delete");
  public getDirectoryDetail = (option?: IHttpRequest) => send(API.directoryBase, option, "get");
  public delFile = (option?: IHttpRequest) => send(API.fileDetail, option, "delete");

  // city
  public getCityList = (option?: IHttpRequest) => send(API.getCityList, option, "get");
  // 验证码
  public sendSms = (option?: IHttpRequest) => send(API.sendSms, option);
  // tenant
  public addTenant = (option?: IHttpRequest) => send(API.baseTenant, option);
  // 新保云平台用户相关服务
  public skcuserValidate = (option?: IHttpRequest) => send(API.skcuserValidate, option);
  public skcRegister = (option?: IHttpRequest) => send(API.skcRegister, option);
  public getMyTenants = (option?: IHttpRequest) => send(API.getMyTenants, option, "get");
  // user
  public verify = (option?: IHttpRequest) => send(API.verify, option);
  public login = (option?: IHttpRequest) => send(API.login, option);
  public logout = (option?: IHttpRequest) => send(API.logout, option, "get");
  public getLoginInfo = (option?: IHttpRequest) => send(API.getLoginInfo, option, "get");

  public addUser = (option?: IHttpRequest) => send(API.baseUser, option);
  public editUser = (option?: IHttpRequest) => send(API.baseUser, option, "put");
  public deleteUser = (option?: IHttpRequest) => send(API.deleteUser, option, "delete");

  public changeUserStatus = (option?: IHttpRequest) => send(API.changeUserStatus, option, "put");
  public resetUserPwd = (option?: IHttpRequest) => send(API.resetUserPwd, option);
  public getSKCUserDetail = (option?: IHttpRequest) => send(API.getSKCUserDetail, option, "get");
  public getUserPage = (option?: IHttpRequest) => send(API.getUserPage, option);
  public getUserDetail = (option?: IHttpRequest) => send(API.getUserDetail, option, "get");
  public getUserOwnData = (option?: IHttpRequest) => send(API.getUserOwnData, option, "get");
  public grantUserData = (option?: IHttpRequest) => send(API.grantUserData, option);
  public getUserOwnRole = (option?: IHttpRequest) => send(API.getUserOwnRole, option, "get");
  public grantUserRole = (option?: IHttpRequest) => send(API.grantUserRole, option);
  public changePassword = (option?: IHttpRequest) => send(API.changePassWord, option);
  public skcuser = (option?: IHttpRequest) => send(API.skcuser, option, "put");

  // app
  public addApp = (option?: IHttpRequest) => send(API.baseApp, option);
  public editApp = (option?: IHttpRequest) => send(API.baseApp, option, "put");
  public deleteApp = (option?: IHttpRequest) => send(API.deleteApp, option, "delete");

  public getAppPage = (option?: IHttpRequest) => send(API.getAppPage, option);
  public getAppList = (option?: IHttpRequest) => send(API.getAppList, option, "get");
  public setAppAsDefault = (option?: IHttpRequest) => send(API.setAppAsDefault, option);
  public changeAppStatus = (option?: IHttpRequest) => send(API.changeAppStatus, option);

  // role
  public addRole = (option?: IHttpRequest) => send(API.baseRole, option);
  public editRole = (option?: IHttpRequest) => send(API.baseRole, option, "put");
  public deleteRole = (option?: IHttpRequest) => send(API.deleteRole, option, "delete");

  public getRolePage = (option?: IHttpRequest) => send(API.getRolePage, option);
  public getRoleList = (option?: IHttpRequest) => send(API.getRoleList, option, "get");
  public roleGrantMenu = (option?: IHttpRequest) => send(API.roleGrantMenu, option);
  public roleGrantData = (option?: IHttpRequest) => send(API.roleGrantData, option);
  public getRoleOwnMenu = (option?: IHttpRequest) => send(API.getRoleOwnMenu, option, "get");
  public getRoleOwnData = (option?: IHttpRequest) => send(API.getRoleOwnData, option, "get");

  // log
  public getExLogPage = (option?: IHttpRequest) => send(API.getExLogPage, option);
  public getOpLogPage = (option?: IHttpRequest) => send(API.getOpLogPage, option);
  public getVisLogPage = (option?: IHttpRequest) => send(API.getVisLogPage, option);

  // menu
  public menuChange = (option?: IHttpRequest) => send(API.menuChange, option);
  public treeForGrant = (option?: IHttpRequest) => send(API.treeForGrant, option, "get");
  public getMenuList = (option?: IHttpRequest) => send(API.getMenuList, option);
  public addMenu = (option?: IHttpRequest) => send(API.baseMenu, option);
  public editMenu = (option?: IHttpRequest) => send(API.baseMenu, option, "put");
  public delMenu = (option?: IHttpRequest) => send(API.delMenu, option, "delete");

  // org
  public addOrg = (option?: IHttpRequest) => send(API.baseOrg, option);
  public editOrg = (option?: IHttpRequest) => send(API.baseOrg, option, "put");
  public deleteOrg = (option?: IHttpRequest) => send(API.deleteOrg, option, "delete");

  public getOrgTree = (option?: IHttpRequest) => send(API.getOrgTree, option, "get");
  public getOrgPage = (option?: IHttpRequest) => send(API.getOrgPage, option);
  public getOrgList = (option?: IHttpRequest) => send(API.getOrgList, option, "get");

  // pos
  public addPos = (option?: IHttpRequest) => send(API.basePos, option);
  public editPos = (option?: IHttpRequest) => send(API.basePos, option, "put");
  public deletePos = (option?: IHttpRequest) => send(API.basePos, option, "delete");
  public getPosPage = (option?: IHttpRequest) => send(API.getPosPage, option);
  public getPosList = (option?: IHttpRequest) => send(API.getPosList, option, "get");

  // tag
  public getTagPage = (option?: IHttpRequest) => send(API.getTagPage, option);
  public editTag = (option?: IHttpRequest) => send(API.baseTag, option, "put");
  public addTag = (option?: IHttpRequest) => send(API.baseTag, option);
  public delTag = (option?: IHttpRequest) => send(API.baseTag, option, "delete");
  public getTagList = (option?: IHttpRequest) => send(API.getTagList, option);

  // baseItem
  public addBaseItem = (option?: IHttpRequest) => send(API.baseItem, option);
  public editBaseItem = (option?: IHttpRequest) => send(API.baseItem, option, "put");
  public delBaseItem = (option?: IHttpRequest) => send(API.delBaseItem, option, "delete");
  public getBaseItemPage = (option?: IHttpRequest) => send(API.getBaseItemPage, option);
  public getBaseItemDetail = (option?: IHttpRequest) => send(API.delBaseItem, option, "get");

  // baseItemType
  public addBaseItemType = (option?: IHttpRequest) => send(API.baseItemType, option);
  public editBaseItemType = (option?: IHttpRequest) => send(API.baseItemType, option, "put");
  public delBaseItemType = (option?: IHttpRequest) => send(API.delBaseItemType, option, "delete");
  public getBaseItemTypePage = (option?: IHttpRequest) => send(API.getBaseItemTypePage, option);
  public getBaseItemTypeList = (option?: IHttpRequest) => send(API.getBaseItemTypeList, option, "get");
  public baseItemUpFile = (option?: IHttpRequest) => send(API.baseItemUpFile, option);
  // 机构
  public getHospitalPage = (option?: IHttpRequest) => send(API.getHospitalPage, option);
  public delHospital = (option?: IHttpRequest) => send(API.hospitalDetail, option, "delete");
  public addHospital = (option?: IHttpRequest) => send(API.baseHospital, option);
  public editHospital = (option?: IHttpRequest) => send(API.baseHospital, option, "put");
  public getHospital = (option?: IHttpRequest) => send(API.hospitalDetail, option, "get");
  public addScheduling = (option?: IHttpRequest) => send(API.addScheduling, option);
  public setScheduling = (option?: IHttpRequest) => send(API.setScheduling, option);
  public getSchedulingDetail = (option?: IHttpRequest) => send(API.schedulingDetail, option, "get");
  public setSchedulingStatus = (option?: IHttpRequest) => send(API.setSchedulingStatus, option, "put");
  public updateOrgSeting = (option?: IHttpRequest) => send(API.updateOrgSeting, option, "put");
  public getOrgSetingDetail = (option?: IHttpRequest) => send(API.getOrgSetingDetail, option, "get");
  public getPhysicalSeting = (option?: IHttpRequest) => send(API.getPhysicalSeting, option, "get");
  public setPhysicalDateExt = (option?: IHttpRequest) => send(API.setPhysicalDateExt, option);
  public setPhysicalDateStatus = (option?: IHttpRequest) => send(API.setPhysicalDateStatus, option, "put");
  // 套餐
  public getPackagePage = (option?: IHttpRequest) => send(API.getPackagePage, option);
  public delPackage = (option?: IHttpRequest) => send(API.packageDetail, option, "delete");
  public getPackage = (option?: IHttpRequest) => send(API.packageDetail, option, "get");
  public editPackage = (option?: IHttpRequest) => send(API.basepackage, option, "put");
  public addPackage = (option?: IHttpRequest) => send(API.basepackage, option);
  public getPackageHospRel = (option?: IHttpRequest) => send(API.getPackageHospRel, option, "get");
  public operationPackageHospRel = (option?: IHttpRequest) => send(API.operationPackageHospRel, option);
  public getPackageItems = (option?: IHttpRequest) => send(API.getPackageItems, option);
  public updatePackageItem = (option?: IHttpRequest) => send(API.updatePackageItem, option);
  // 商品
  public addGoodsCategory = (option?: IHttpRequest) => send(API.baseGoodsCategory, option);
  public editGoodsCategory = (option?: IHttpRequest) => send(API.baseGoodsCategory, option, "put");
  public deleteGoodsCategory = (option?: IHttpRequest) => send(API.goodsCategoryDetail, option, "delete");
  public getGoodsCategoryDetail = (option?: IHttpRequest) => send(API.goodsCategoryDetail, option);
  public getGoodsCategoryPage = (option?: IHttpRequest) => send(API.getGoodsCategoryPage, option);
  public getGoodsCategoryList = (option?: IHttpRequest) => send(API.getGoodsCategoryList, option);
  public addGoods = (option?: IHttpRequest) => send(API.baseGoods, option);
  public editGoods = (option?: IHttpRequest) => send(API.baseGoods, option, "put");
  public getGoodsPage = (option?: IHttpRequest) => send(API.getGoodsPage, option);
  public getGoodsPricePage = (option?: IHttpRequest) => send(API.getGoodsPricePage, option);
  public deleteGoods = (option?: IHttpRequest) => send(API.goodsDetail, option, "delete");
  public getGoodsDetail = (option?: IHttpRequest) => send(API.goodsDetail, option, "get");
  public onOffshelf = (option?: IHttpRequest) => send(API.getGoodsOrderPage, option);
  public getDistributionGoods = (option?: IHttpRequest) => send(API.getDistributionGoods, option);
  // 商品订单
  public getGoodsOrderPage = (option?: IHttpRequest) => send(API.getGoodsOrderPage, option);
  public getGoodsOrderdetail = (option?: IHttpRequest) => send(API.getGoodsOrderdetail, option, "get");
  public changeOrderReceiptInfo = (option?: IHttpRequest) => send(API.changeOrderReceiptInfo, option);
  public orderDelivery = (option?: IHttpRequest) => send(API.orderDelivery, option, "put");
  public addOrderRemark = (option?: IHttpRequest) => send(API.orderRemark, option);
  public changeOrderCost = (option?: IHttpRequest) => send(API.changeOrderCost, option);
  public getOrderExpress = (option?: IHttpRequest) => send(API.getOrderExpress, option, "get");
  // express
  public getExpressList = (option?: IHttpRequest) => send(API.getExpressList, option, "get");
  public addTemplate = (option?: IHttpRequest) => send(API.beasExpressTemplate, option);
  public editTemplate = (option?: IHttpRequest) => send(API.beasExpressTemplate, option, "put");
  public getTemplatePage = (option?: IHttpRequest) => send(API.getTemplatePage, option);
  public deleteTemplate = (option?: IHttpRequest) => send(API.expressTemplateDetail, option, "delete");
  public getTemplateDetail = (option?: IHttpRequest) => send(API.expressTemplateDetail, option, "get");
  public getExpressTemplateList = (option?: IHttpRequest) => send(API.getExpressTemplateList, option);
  // order
  public getCheckupOrderPage = (option?: IHttpRequest) => send(API.getCheckupOrderPage, option);
  public onInvalidOrder = (option?: IHttpRequest) => send(API.onInvalidOrder, option);
  public changeReserve = (option?: IHttpRequest) => send(API.changeReserve, option, "put");
  public getOrderDetail = (option?: IHttpRequest) => send(API.getOrderDetail, option, "get");
  // 分销
  public updateDistributionGoods = (option?: IHttpRequest) => send(API.baseDistributionGoods, option, "put");
  public addDistributionGoods = (option?: IHttpRequest) => send(API.baseDistributionGoods, option);
  public getDistributionGoodsDetail = (option?: IHttpRequest) => send(API.getDistributionGoodsDetail, option, "get");
  public getDistributionGoodsPage = (option?: IHttpRequest) => send(API.getDistributionGoodsPage, option);
  public getDistributionMarket = (option?: IHttpRequest) => send(API.getDistributionMarket, option);
  public disGoodsOnOffshelf = (option?: IHttpRequest) => send(API.disGoodsOnOffshelf, option, "put");
  public getGoodsDistribution = (option?: IHttpRequest) => send(API.getGoodsDistribution, option, "get");
  public getDistGoodsPrice = (option?: IHttpRequest) => send(API.getDistGoodsPrice, option);
  // 代理
  public getAgencyoodsPage = (option?: IHttpRequest) => send(API.getAgencyoodsPage, option);
  public addAgencyGoods = (option?: IHttpRequest) => send(API.addAgencyGoods, option);
  public agencyGoodsOnOffshelf = (option?: IHttpRequest) => send(API.agencyGoodsOnOffshelf, option, "put");
  // shop
  public getShopDetail = (option?: IHttpRequest) => send(API.getShopDetail, option, "get");
  public addOrModify = (option?: IHttpRequest) => send(API.addOrModify, option);
  // 客户管理
  public getMemberList = (option?: IHttpRequest) => send(API.getMemberList, option);
  public getMemberDetail = (option?: IHttpRequest) => send(API.getMemberDetail, option, "get");
  public addToBlack = (option?: IHttpRequest) => send(API.addToBlack, option);
  public removeFromBlack = (option?: IHttpRequest) => send(API.removeFromBlack, option);
  public memberOneAddTag = (option?: IHttpRequest) => send(API.memberOneAddTag, option);
  // 客户等级
  public addMemberLeval = (option?: IHttpRequest) => send(API.addAndUpdLeval, option);
  public updateMemberLeval = (option?: IHttpRequest) => send(API.addAndUpdLeval, option, "put");
  public deleteMemberLeval = (option?: IHttpRequest) => send(API.getAndDelLeval, option, "delete");
  public getMemberLeval = (option?: IHttpRequest) => send(API.getAndDelLeval, option, "get");
  public memberLevalList = (option?: IHttpRequest) => send(API.levalList, option);
  public memberLevalPagingList = (option?: IHttpRequest) => send(API.levalPagingList, option);
  // 客户标签
  public addMemberTag = (option?: IHttpRequest) => send(API.addAndUpdTag, option);
  public updateMemberTag = (option?: IHttpRequest) => send(API.addAndUpdTag, option, "put");
  public deleteMemberTag = (option?: IHttpRequest) => send(API.getAndDelTag, option, "delete");
  public memberTagPagingList = (option?: IHttpRequest) => send(API.tagPagingList, option);
  public memberTagList = (option?: IHttpRequest) => send(API.tagList, option);
  public memberAddTags = (option?: IHttpRequest) => send(API.memberAddTags, option);

  // 新保云平台服务详情
  public skcServerPageList = (option?: IHttpRequest) => send(API.skcServerPageList, option);
  public getSkcServer = (option?: IHttpRequest) => send(API.getSkcServer, option, "get");

  // 服务下单
  public skcServerOrder = (option?: IHttpRequest) => send(API.skcServerOrder, option);
  public skcServerOrderPageList = (option?: IHttpRequest) => send(API.skcServerOrderPageList, option);
  public skcServerOrderConfirm = (option?: IHttpRequest) => send(API.skcServerOrderConfirm, option);
  public getSkcServerOrder = (option?: IHttpRequest) => send(API.getSkcServerOrder, option, "get");
  public getPayResult = (option?: IHttpRequest) => send(API.getPayResult, option, "get");
  public cancelOrder = (option?: IHttpRequest) => send(API.cancelOrder, option, "put");
  public offlinePay = (option?: IHttpRequest) => send(API.offlinePay, option);
  public offlinePayAudit = (option?: IHttpRequest) => send(API.offlinePayAudit, option);
}
